module.exports = __webpack_public_path__ + "img/7e4cf27.png";